module.exports = __webpack_public_path__ + "static/media/carrara-reg-webfont.06737d89.woff";